import styled from 'styled-components';

export const Section = styled.div`
  padding: 2.4rem 0 4rem;

  @media screen and (min-width: 650px) {
    padding: 4rem 0 8rem;
  }
`;
